import api from './index'

const axios = require('axios')

export default {
    getAll: () => {
        const path = '/deals/all'

        return api.handling(axios.get(path))
    },

    getByID: (id) => {
        const path = `/deals/${id}`

        return api.handling(axios.get(path))
    },

    updateByID: (id, data) => {
        const path = `/deals/${id}`

        return api.handling(axios.put(path, data))
    },

    create: (data) => {
        const path = '/deals/create'

        return api.handling(axios.post(path, data))
    }
}
